import type { SchemaMemberShow } from 'api'

export const selectTokenInfo = (state: any) => state.user.tokenInfo
export const selectUserInfo = (state: any): SchemaMemberShow => state.user?.userInfo
export const selectUserName = (state: any) => state.user?.userInfo?.name
export const selectInviteCode = (state: any) => state.user?.inviteCode
export const selectPreference = (state: any) => state.user?.preference
export const selectIsTempLogin = (state: any) => state.user.isTempLogin
